import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const css = `
  .bn-spacer { height: 0; }
  .bn { display: none; }
  @media (max-width: 767px) {
    .bn-spacer { height: calc(78px + env(safe-area-inset-bottom)); }
    .bn { display: flex; position: fixed; left: 0; right: 0; bottom: 0; z-index: 300; background: #fff; border-top: 1px solid #E3DCCF;
      padding-bottom: env(safe-area-inset-bottom); box-shadow: 0 -6px 20px rgba(23,59,52,0.06); }
    .bn button { flex: 1; min-height: 66px; background: none; border: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;
      font-family: 'Inter', system-ui, sans-serif; font-size: 11.5px; font-weight: 600; color: #8a8a82; cursor: pointer; -webkit-tap-highlight-color: transparent; }
    .bn button svg { width: 24px; height: 24px; stroke: currentColor; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
    .bn button.on { color: #E4572E; }
  }
`;

const ICONS = {
  parcours: <svg viewBox="0 0 24 24"><path d="M4 11l8-7 8 7v9a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z" /></svg>,
  clara: <svg viewBox="0 0 24 24"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" /></svg>,
  fiches: <svg viewBox="0 0 24 24"><path d="M7 3h8l4 4v14H7z" /><path d="M14 3v5h5M10 13h6M10 17h6" /></svg>,
  profil: <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6 8-6s8 2 8 6" /></svg>,
};

export function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const mod = user?.moduleActuel && user.moduleActuel >= 1 ? user.moduleActuel : 1;

  const tabs = [
    { key: 'parcours', label: 'Parcours', to: '/parcours', on: pathname === '/parcours' },
    { key: 'clara', label: 'Clara', to: `/module/${mod}`, on: pathname.startsWith('/module') },
    { key: 'fiches', label: 'Ma marque', to: '/ma-marque', on: pathname === '/ma-marque' || pathname === '/tableau-de-bord' },
    { key: 'profil', label: 'Profil', to: '/profil', on: pathname === '/profil' },
  ];

  return (
    <>
      <style>{css}</style>
      <div className="bn-spacer" />
      <nav className="bn" aria-label="Navigation principale">
        {tabs.map(t => (
          <button key={t.key} className={t.on ? 'on' : ''} onClick={() => navigate(t.to)} aria-current={t.on ? 'page' : undefined}>
            {ICONS[t.key]}
            {t.label}
          </button>
        ))}
      </nav>
    </>
  );
}
